/**
 * Azure AD Configuration for Group-Based Authentication
 * 
 * This configuration enables the application to use Azure AD Security Groups
 * for authorization instead of maintaining a static email whitelist.
 */

export const AZURE_AD_CONFIG = {
  /**
   * Object ID of the Azure AD Security Group that contains authorized users
   * Group Name: ShipmentCoPilot_AllowedUsers (example)
   * Object ID: 093ae3e0-307c-4108-9c81-dc07b5a734d6
   */
  AUTHORIZED_GROUP_ID: "093ae3e0-307c-4108-9c81-dc07b5a734d6",
  
  /**
   * Enable group-based authentication
   * Set to true to use Azure AD groups, false to use email whitelist
   */
  USE_GROUP_BASED_AUTH: process.env.REACT_APP_USE_GROUP_AUTH !== 'false', // Default to true
  
  /**
   * Enable fallback to email whitelist if group check fails
   * Useful during migration period
   */
  FALLBACK_TO_EMAIL_WHITELIST: process.env.REACT_APP_FALLBACK_TO_EMAIL !== 'false', // Default to true
  
  /**
   * Enable verbose logging for authentication debugging
   */
  ENABLE_AUTH_LOGGING: process.env.REACT_APP_AUTH_LOGGING === 'true',
  
  /**
   * Group claim name in ID token (usually 'groups')
   */
  GROUPS_CLAIM_NAME: 'groups'
} as const;

/**
 * Configuration instructions for Azure AD App Registration:
 * 
 * 1. Go to Azure Portal → App Registrations → [Your App]
 * 2. Navigate to "Token Configuration" 
 * 3. Click "Add groups claim"
 * 4. Select "Security groups"
 * 5. Check "ID" token option
 * 6. Optional: Choose "Group ID" (recommended) vs "Group name"
 * 7. Save the configuration
 * 
 * After configuration, ID tokens will include a "groups" claim with an array
 * of group Object IDs that the user is a member of.
 */

export type AzureAdAuthConfig = typeof AZURE_AD_CONFIG;
